import React from 'react';
import { ExcelTableCellProps } from '../../TableCell';
import { observer } from 'mobx-react';
import { getDomIdByFieldKey } from '../../../../util/typeUtil';
import _ from 'lodash';
import Textarea from './Textarea';
import RichText from './RichText';
import ReadonlyText from './ReadonlyText';
// import jQuery from 'jquery';
import MapPic from '../../../cube-map/MapPic';
import { transHTML } from '../input-element/wf-form-input/util';
@observer
export default class TextareaElement extends React.Component<ExcelTableCellProps, any> {
    componentDidMount() {
        const { cell, card, form } = this.props;
        const { fieldtype } = card.getFieldProps(cell.getPath())
        if (fieldtype == '2') {
            const bindObj = form.$(cell.getPath());
            const fieldName = getDomIdByFieldKey(bindObj.path);
            _.set(window, `FORM_CK_REF.${fieldName}`, this.refs[fieldName]);
        }
    }

    ckfocus() {
        const { cell, card, form } = this.props;
        const { fieldtype } = card.getFieldProps(cell.getPath())
        if (fieldtype == '2') {
            const bindObj = form.$(cell.getPath());
            const fieldName = getDomIdByFieldKey(bindObj.path);
            (this.refs[fieldName] as any).getEditor().focus();
        }
    }

    render() {
        const { cell, form, card, className, excel } = this.props;
        const path = cell.getPath();
        const bindObj = form.$(path);
        const bind = bindObj.bind();
        const fieldName = getDomIdByFieldKey(bindObj.path);
        const { viewAttr: _viewAttr, isEdit, isMandatory } = bindObj;
        let { fieldtype, textheight, placeholder } = card.getFieldProps(path);
        const { quickEditStore,getDetailFormValues} = card;
        //QC613733 QC620582 问题处理不合适，迁移上来
        const style: any = cell.style || {};
        let viewAttr = _viewAttr ? _viewAttr : (isMandatory ? 3 : (isEdit ? 2 : 1));
        if (excel.detailProps && excel.detailProps.hasOwnProperty("isEdit") && card.params.type == '2') {
            //如果明细表字段，设置了不可编辑已有明细
            if (getDetailFormValues(form).dtl_id && !excel.detailProps["isEdit"]) {
                viewAttr = 1;
            }
        }
        const mapAttr = card.mapStore.getMapAttr(path);
        const showMapIcon = mapAttr && mapAttr.caltype == '5' && (!mapAttr.mapdistype || mapAttr.mapdistype.indexOf('S') < 0);
        if (mapAttr && mapAttr.caltype == '5' && mapAttr.mapdistype && mapAttr.mapdistype.indexOf('S') >= 0) {
            return (
                <div style={{ minHeight: 200 }}>
                    <MapPic address={bind.value} />
                    <input  {...bind} id={fieldName} type="hidden" />
                </div>
            )
        }
        if (fieldtype != '2') {
            placeholder = bind.placeholder || placeholder;
            if (card.detailMap[`${fieldName}`] && card.detailMap[`${fieldName}`]['emptyShowContent']) {
                placeholder = card.detailMap[`${fieldName}`]['emptyShowContent'];
            }
            const canQuickedit = bindObj.isquickedit && viewAttr == '1';
            if (viewAttr == '1') {//只读
                const bind = form.$(path).bind();
                let value = transHTML(bind.value)
                return (
                    <div className={`${canQuickedit ? 'cube-card-editformitem ' : 'cube-card-editformitem2'} fieldValue ${className}`} data-fieldattr={viewAttr} data-fieldmark={fieldName} {...cell.cellProps}
                        style={{ paddingRight: "13px", ...cell.cellProps.style }}
                        onClick={() => { canQuickedit && quickEditStore.lockEditFormItem(fieldName); }}
                    >
                        <span
                            className={`wea-textarea-normal wea-field-readonly ${className}`}
                            style={{ color: style.color, width: '96%' }}
                            id={fieldName}
                            dangerouslySetInnerHTML={{ __html: value }}
                        />
                        {showMapIcon && <i className="icon-coms-position" style={{ marginLeft: 5 }} onClick={this.handleMap.bind(this, bind.value, path, form)} />}
                        <span className="editicon"><i className="icon-coms-edit" ></i></span>
                    </div>
                )
            }
            return (
                <div className={`${canQuickedit ? 'cube-card-editformitem ' : 'cube-card-editformitem2'} fieldValue ${className}`} data-fieldattr={viewAttr} data-fieldmark={fieldName} {...cell.cellProps}
                    style={{ paddingRight: "13px", ...cell.cellProps.style }}
                    onClick={() => { canQuickedit && quickEditStore.lockEditFormItem(fieldName); }}
                >
                    <Textarea
                        path={path}
                        form={form}
                        fieldName={fieldName}
                        viewAttr={viewAttr}
                        placeholder={placeholder}
                        textheight={textheight == 0 ? 4 : textheight}
                        // style={{ color: style.color, width: viewAttr == '1' ? 'auto' : '96%' }}
                        style={{ color: style.color, width: '96%' }}
                    />
                    {showMapIcon && <i className="icon-coms-position" style={{ marginLeft: 5 }} onClick={this.handleMap.bind(this, bind.value, path, form)} />}
                    <span className="editicon"><i className="icon-coms-edit" ></i></span>
                </div>
            )
        } else {
            if (viewAttr == 2 || viewAttr == 3 || viewAttr == 5) {
                const ckConfig = {} as any;
                ckConfig.toolbar = [['Source', '-', 'Bold', 'Italic', 'Underline', 'Strike', '-',
                    'Format', 'Font', 'FontSize', 'TextColor', 'BGColor', '-',
                    'NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-',
                    'Link', 'Unlink', '-', 'Table', '-', 'Iframe', 'HorizontalRule', 'SpecialChar', '-', 'CopyFormatting', 'RemoveFormat', 'PasteText',
                    'Undo', 'Redo', 'Maximize',"Html5video"
                ]];
                ckConfig.extraPlugins = 'autogrow,html5video';
                ckConfig.height = 40 * textheight;
                ckConfig['autoGrow_maxHeight'] = 40 * textheight;
                ckConfig['autoGrow_minHeight'] = 40 * textheight;
                ckConfig.removePlugins = 'resize';
                ckConfig.uploadUrl = '/api/doc/upload/uploadFile';
                ckConfig.fontSize_defaultLabel = '12';
                ckConfig.font_names = '仿宋_GB2312/FangSong_GB2312;宋体/SimSun;微软雅黑/Microsoft YaHei;楷体/KaiTi;黑体/SimHei;Arial/Arial, Helvetica, sans-serif;新宋体/NSimSun;楷体_GB2312/KaiTi_GB2312;';
                ckConfig.font_defaultLabel = '微软雅黑';
                ckConfig.fontSize_sizes = '8/8px;9/9px;10/10px;11/11px;12/12px;14/14px;16/16px;18/18px;20/20px;22/22px;24/24px;26/26px;28/28px;36/36px;';
                ckConfig.startupFocus = false;
                ckConfig.placeholder = bindObj.$placeholder;
                return <div className={`cube-card-editformitem2 fieldValue ${className}`} data-fieldattr={viewAttr} data-fieldmark={fieldName} {...cell.cellProps}>
                    <RichText
                        path={path}
                        fieldName={fieldName}
                        field={bindObj}
                        viewAttr={viewAttr}
                        extentsConfig={this.initExtentsConfig()}
                        onToolsChange={this.buttonBtnChange}
                        ckConfig={ckConfig}
                    />
                </div>
            } else {
                const canQuickedit = bindObj.isquickedit && viewAttr == '1';
                return <div className={`${canQuickedit ? 'cube-card-editformitem ' : 'cube-card-editformitem2'} fieldValue ${className}`} data-fieldattr={viewAttr} style={{ overflowX: "auto", overflowY: "hidden" }} data-fieldmark={fieldName}
                    onClick={() => { canQuickedit && quickEditStore.lockEditFormItem(fieldName); }}
                >
                    <ReadonlyText path={path} form={form} fieldName={fieldName} />
                    <span className="editicon"><i className="icon-coms-edit" ></i></span>
                </div>
            }
        }
    }

    initExtentsConfig() {
        const extentsConfig: any[] = [];
        extentsConfig.push({
            name: 'Upload',
            type: 'image',
            show: <div className="wea-cb-item">
                <span className={`wea-cbi-icon cke_button_icon cke_button__image_icon`} />
            </div>,
            uploadUrl: '/api/doc/upload/uploadFile',
            category: 'all',
            limitType: 'jpg,gif,png',
            title: '上传图片',
            needLoading: false
        });
        return extentsConfig;
    }

    buttonBtnChange = (name = '', _ = '', list = [], type = '') => {
        const html: string[] = [];
        if (name === 'Upload') {
            if (type === 'image') {
                list.map((item: any) => {
                    const imglink = `/weaver/weaver.file.FileDownload?fileid=${item.fileidCode}`;
                    html.push(`<img class='formImgPlay' src='${imglink}' data-imgsrc='${imglink}' onclick="window.imageCarousel(this)" alt=''/>`);
                });
            }
        }
        return html.join('');
    }
    handleMap = (value, path, form) => {
        if (window['getLnglat']) {
            const fieldName = getDomIdByFieldKey(form.$(path).path);
            let index = "";
            if (fieldName.indexOf("_") > -1) {//明细表
                index = fieldName.substring(fieldName.indexOf("_") + 1);
            }
            window['getLnglat'](path, form, index);
        }
        this.props.card.mapStore.onShow(value, path, form);
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/cell-field/textarea-element/index.tsx